import Component from '../abstracts/Component';

export default class ShowPasswordComponent extends Component {
  get SELECTORS() {
    return {
      passwordToggle: '[data-toggle-password]',
    };
  }

  get CLASSES() {
    return {
      passwordVisible: 'icon-eye-on',
      passwordNotVisible: 'icon-eye-off',
    };
  }

  constructor() {
    super();
  }

  bindEvents() {
    this.$on(
      'click',
      ({ event }) => {
        event.preventDefault();
        const input = event.currentTarget.parentElement.querySelector('input');
        const inputType = input.getAttribute('type');

        switch (inputType) {
          case 'password':
            input.setAttribute('type', 'text');
            event.currentTarget.classList.remove(this.CLASSES.passwordVisible);
            event.currentTarget.classList.add(this.CLASSES.passwordNotVisible);
            break;
          case 'text':
            input.setAttribute('type', 'password');
            event.currentTarget.classList.remove(
              this.CLASSES.passwordNotVisible
            );
            event.currentTarget.classList.add(this.CLASSES.passwordVisible);
            break;
        }
      },
      'body',
      this.SELECTORS.passwordToggle
    );
  }

  render() {
    this.log('Rendering...');
    this.bindEvents();
  }
}
